import React from "react";
import loading from "../assets/loading.svg";

type LoadingProps  = {
  message?: string
  className?: string
}
const Loading = (props?: LoadingProps) => (
 <div className="grid justify-items-center">
  
 <div className={ props?.className || "spinner"}>
    <img src={loading} alt="Loading" />
    
  </div>
  <div>
     {props?.message}
   </div>
  </div>
);

export default Loading;
